import { PropsWithChildren } from 'react';

export const CheckboxGroup = ({ children }: PropsWithChildren) => (
    <div className="form-item__checkboxes">{children}</div>
);
